import React from 'react';

// helpers
import { FormAutocompleteProps } from '@ui';
import { intakeFormAPI, ServiceProviderFromQuery } from 'api/crm/intakeFormAPI';

// components
import { FormAutocomplete } from '@ui';

export type IProps = FormAutocompleteProps<ServiceProviderFromQuery>;

const ServiceProvidersAutocomplete = (props: IProps) => {
  const fetchOptions = async (
    searchText: string,
    page: number,
    limit: number,
  ) => {
    const { data, total } = await intakeFormAPI.fetchServiceProviders({
      search: searchText.trim(),
      page,
      limit,
    });

    return {
      total,
      options: data.map((e) => ({
        id: e._id,
        label: e.name,
        model: e,
      })),
    };
  };

  return <FormAutocomplete {...props} fetchData={fetchOptions} />;
};

export default ServiceProvidersAutocomplete;
